/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { Box } from '@mui/material';
import { ParagraphBlockData } from '../../../../models/courses';
import 'react-quill/dist/quill.snow.css';

interface ReactQuillProps {
  theme?: string;
  value: string;
  onChange: (_value: string) => void;
  style?: React.CSSProperties;
  readOnly?: boolean;
}

const ReactQuill =
  require('react-quill') as React.ComponentType<ReactQuillProps>;

interface ParagraphBlockProps {
  data: ParagraphBlockData;
  onChange: (_data: ParagraphBlockData) => void;
  disabled?: boolean;
}

export const ParagraphBlock: React.FC<ParagraphBlockProps> = ({
  data,
  onChange,
  disabled,
}) => {
  return (
    <Box sx={{ pb: 6 }}>
      <ReactQuill
        theme="snow"
        value={data.text}
        onChange={(val) => onChange({ text: val })}
        style={{ height: 150 }}
        readOnly={disabled}
      />
    </Box>
  );
};
